import { api } from "./api";
import type { CompletionPayload, ProgressUpdate } from "@/types/lesson";

export const progressApi = {
  updateProgress: async (payload: ProgressUpdate): Promise<void> => {
    await api.post(`/api/lessons/${payload.lessonId}/progress`, payload);
  },
  completeLesson: async (payload: CompletionPayload): Promise<void> => {
    await api.post(`/api/lessons/${payload.lessonId}/complete`, payload);
  },
  submitScore: async (
    lessonId: string,
    score: number,
    totalQuestions: number,
  ): Promise<void> => {
    // Server re-validates the score server-side; the client value is a hint, not authoritative.
    await api.post(`/api/lessons/${lessonId}/score`, { score, totalQuestions });
  },
};
